import React from 'react'

import { StyledLabel, StyledRequired, StyledInternalPlaceholder, StyledTooltip } from './styles'
import { LabelProps } from './types'
import { Tooltip } from '@grupoboticario/flora-react-tooltip'
import { QuestionMarkCircleIcon } from '@grupoboticario/flora-react-icons'

export const Label = ({
  htmlFor,
  children,
  labelPosition = 'internal',
  surfaceColor = 'light',
  hasLeftIcon,
  hasRightIcon,
  status,
  placeholder,
  required,
  disabled,
  tooltipText,
  ...props
}: LabelProps) => {
  return (
    <StyledLabel
      htmlFor={htmlFor}
      labelPosition={labelPosition}
      surfaceColor={surfaceColor}
      status={status}
      hasLeftIcon={hasLeftIcon}
      hasRightIcon={hasRightIcon}
      disabled={disabled}
      {...props}
    >
      <span>{children}</span>
      {required && (
        <StyledRequired surfaceColor={surfaceColor} aria-hidden="true">
          *
        </StyledRequired>
      )}

      {tooltipText && (
        <StyledTooltip>
          <Tooltip align="start" direction="top" showArrow size="small" text={tooltipText}>
            <span tabIndex={0}>
              <QuestionMarkCircleIcon
                size={16}
                color="$nonInteractiveAuxiliar"
                data-testid="tooltip-trigger"
              />
            </span>
          </Tooltip>
        </StyledTooltip>
      )}

      {placeholder && labelPosition === 'internal' && (
        <StyledInternalPlaceholder surfaceColor={surfaceColor} aria-hidden="true">
          {placeholder}
        </StyledInternalPlaceholder>
      )}
    </StyledLabel>
  )
}
